module.exports = __webpack_public_path__ + "img/8ffe03a.jpg";